module.exports = __webpack_public_path__ + "img/TN.91bd57f0.jpg";